import React,{useEffect} from 'react';
import { FaImage } from 'react-icons/fa';
import './AddBannerModal.css';
import Input from '../../../components/Input/Input';

const AddBannerModal = ({
  showModal,
  isEditMode,
  selectedImage,
  setSelectedImage,
  isNewImage,
  setIsNewImage,
  handleDrop,
  handleDragOver,
  handleFileChange,
  saveLoading,
  onSave,
  onClose,
  bannerUrl,
  setBannerUrl
}) => {
  
  useEffect(() => {
    if (showModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [showModal]);

  if (!showModal) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content add-edit-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>{isEditMode ? 'Edit Banner' : 'Add Banner'}</h3>
          <button
            type="button"
            className="modal-close"
            onClick={onClose}
            aria-label="Close"
            disabled={saveLoading}
          >
            ×
          </button>
        </div>

        <div className="profile-form">
          <div className="form-group">
          <Input
            type="url"
            placeholder="Enter URL (optional)"
            value={bannerUrl || ''}
            onChange={(e) => setBannerUrl(e.target.value)}
            className="banner-form-input"
          />
          </div>
          
          <div
            className="upload-area"
            onDragOver={handleDragOver}
            onDrop={handleDrop}
            onClick={() => document.getElementById(isEditMode ? 'edit-banner-upload-input' : 'banner-upload-input').click()}
          >
            <input
              id={isEditMode ? 'edit-banner-upload-input' : 'banner-upload-input'}
              type="file"
              accept="image/*"
              style={{ display: "none" }}
              onChange={handleFileChange}
            />
            {!selectedImage ? (
              <div className="upload-placeholder">
                <FaImage />
                <p>Click to select image or drag and drop</p>
                <span>Supports: JPG, PNG, JPEG</span>
              </div>
            ) : (
              <div className="image-preview-container">
                <img src={selectedImage} alt="Preview" className="image-preview" />
              </div>
            )}
          </div>

          <div className="form-actions">
            <button type="button" onClick={onSave} disabled={saveLoading} aria-busy={saveLoading}>
              {saveLoading ? isEditMode ? 'Updating...' : 'Uploading...' : isEditMode ? 'Update' : 'Upload'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddBannerModal; 